import React from "react";
import { RouteInfoType } from "../../types/types";
import BranchesRegisterPage from "./pages/BranchesRegistryPage";
import SectionLayout from "../../layouts/SectionLayout";
import { Briefcase } from "react-feather";
import BranchDetails from "./pages/BranchDetailsPage";

const branchesRegisterRoutes = [
    {
        id: "branchesRegister",
        path: "/branchesRegister/",
        header: "Клиенты",
        name: "Рестораны",
        icon: <Briefcase/>,
        component: SectionLayout,
        nonCollapsable: true,
        routes: [
            {
                path: "/branchesRegister/general",
                exact: true,
                name: "Рестораны",
                component: BranchesRegisterPage,
            },
            {
                hide: true,
                path: "/branchesRegister/general/:branchId",
                name: "Ресторан",
                component: BranchDetails,
            },
        ]
    }
];

export default branchesRegisterRoutes as RouteInfoType[];
